import ReactDOM from 'react-dom/client';
import App from './App';
import { enableMapSet } from 'immer';

enableMapSet();

ReactDOM.createRoot(document.getElementById('react-mount')!).render(App());

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(new URL('./sw.js', import.meta.url), { type: 'module' })
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}
